import { ReactNode } from 'react'

interface PageContainerProps {
    children: ReactNode
    className?: string
}

export default function PageContainer({ children, className = '' }: PageContainerProps) {
    return (
        <div className={`max-w-7xl w-full mx-auto p-5 md:p-8 page-enter ${className}`}>
            {children}
        </div>
    )
}
